import React from 'react';
import { Button, Drawer } from 'antd';

const ConfirmDrawer = ({ visible, onOk, onCancel }) => {
    return (
        <Drawer
            title='END CHAT'
            placement={'bottom'}
            closable={true}
            visible={visible}
            onClose={onCancel}
            key={'bottom'}
            bodyStyle={{ padding: 0 }}
            headerStyle={{ padding: 12 }}
            drawerStyle={{ border: 'solid 2px #be272d' }}
            height = {'200px'}
        >
            <div className="drawer-content">
                Are you sure you want to end the chat? You'll have to start a new session later.
            </div>
            <Button 
                type="text" 
                style={{ color: '#00f', width: '100%' }}
                onClick={onOk}
            >
                Yes
            </Button>
            <Button 
                type="text" 
                style={{ color: '#00f', width: '100%' }}
                onClick={onCancel}
            >
                No
            </Button>
        </Drawer>
    );
}

export default ConfirmDrawer;